/* eslint-disable react-refresh/only-export-components */
import { useTranslation } from "react-i18next";
import { Route } from "./route";
import { useQuery } from "@tanstack/react-query";
import { client, FullUserDetailsDto } from "@/client";
import { usePermissions } from "@/hooks/use-permissions";
import { useRouteFullPath } from "@/hooks/use-route-full-path";
import NavTabs, {
  NavTabPartialProps,
  TabItem,
} from "@/components/custom/tabs/nav-tabs";

export function useUserTabs(): TabItem[] {
  const { t } = useTranslation();
  const { permissions } = usePermissions();
  return [
    permissions.users.view && {
      title: t("overview"),
      path: "overview",
      requiredPermissions: ["users.view"],
    },
  ].filter(Boolean) as TabItem[];
}

export function UserTabs({ children, ...props }: NavTabPartialProps) {
  const { userId } = Route.useRouteContext();
  const userDetailsQuery = client.users.getUserById.asQueryOptions({
    id: userId,
  });
  const { data } = useQuery(userDetailsQuery);

  return (
    <>
      <NavTabs
        {...props}
        header={`
          ${(data as FullUserDetailsDto)?.user.firstName} 
          ${(data as FullUserDetailsDto)?.user.lastName}`}
        root={useRouteFullPath(Route)}
        items={useUserTabs()}
        className="capitalize"
      >
        {children}
      </NavTabs>
    </>
  );
}
